import Contents from '../Layouts/Contents'
import Credit from '../Layouts/Credits'
import styles from './index.module.scss'

const Policy = () => {
  return (
    <div>
        <div className={styles.layout}>
            <Contents />
            <div className={styles.start}>
                <div>
                    <h1>Privacy Policy</h1>
                    <p>Here you can read the Dreamvast/RainyService privacy policies. Released on August 24, 2022.</p>
                    <p>The Privacy Policy will be updated and developed to bring an even better level of security to you.</p>
                </div>
                <div style={{ padding: '2px 0px' }}>
                    <h3>Before entering the main part, we would like to confirm that we will not and will never sell your personal information to anyone or any 3rd party.</h3>
                </div>
                <div style={{ padding: '20px 0px 1px' }}>
                    <h2>Main Part:</h2>
                </div>
                <div style={{ padding: '5px 0px 10px' }}>
                    <h3>Storage and usage (user)</h3>
                    <p>We store user-id, username and user distinction.</p>
                </div>
                <div style={{ padding: '5px 0px' }}>
                    <div style={{ padding: '5px 0px' }}>
                        <h3>Storage and usage (server)</h3>
                        <p>Dreamvast stores:</p>
                    </div>
                    <div className={styles.markdown}>
                        <p>- Server public information</p>
                        <p>- Configurations</p>
                        <p>- Server name</p>
                        <p>- Server ID</p>
                        <p>- Server avatar</p>
                    </div>
                </div>
                <div style={{ padding: '20px 0px' }}>
                    <h3>Security</h3>
                    <p>We implement a variety of security measures when users order, enter, submit or accessinformation to keep your information safe.</p>
                    <p>But keep in mind that our database can be 99.5% secure but not 100% and we can not guarantee it is really 100% safe.</p>
                </div>
                <div style={{ padding: '20px 0px' }}>
                    <h3>Want us to delete your data?</h3>
                    <p>
                        Personal Data is stored for as long as is required by the purpose for which they were intended
                        collect for. However, if you want us to delete your data, you can request it at
                        anytime by contacting us via email: dreamvast@outlook.com.
                    </p>
                </div>
            </div>
        </div>
        <Credit />
    </div>
  )
}

export default Policy